<template>
  <div class="contact-area w-100">
    <div class="contact w-100" :style="{ background: value.socialMediaIcons?.sectionColor?.backGround }">
      <!-- بخش اطلاعات پایه (Header) -->
        <main v-if="showHeader && value?.buttonName?.trim() && value?.designSettings?.layout !== 'SocialExpandable'">
          <section :style="{ background: value.baseInfo?.sectionColor?.backGround }">
            <div class="contentMedia d-flex flex-column align-center text-center pb-4">
              <v-btn 
                ref="contactBtn" 
                @click="toggleMedia"  
                :class="['elevation-4 py-0 mx-4 mt-4 w-100 glass-effect', { 'active-btn': showMedia }]"                    
                :style="{
                  background: value.socialMediaIcons?.sectionColor?.backGround || 'linear-gradient(45deg, #1976d2, #8e24aa)',
                  color: value.socialMediaIcons?.sectionColor?.text || '#fff',
                }"      
                rounded
              >
                <span class="px-2 py-1">{{ value?.buttonName }}</span>
                <v-icon right dark>{{ showMedia ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
              </v-btn>
            </div>
          </section>
        </main>
      <!-- بخش نمایش چیدمان‌ها -->
      <div :class="['media-container', showMedia ? 'active' : '']">
        <component 
          :is="value?.designSettings?.layout||'SocialList'"
          :medias="resolvedMedias"
          :value="value"
          :get-social-color="getSocialColor"
          :hex-to-rgba="hexToRgba"
          @go-to-url="goToUrl"
          :style="{
                background: value.socialMediaIcons?.sectionColor?.backGround || 'linear-gradient(45deg, #1976d2, #8e24aa)',
                color: value.socialMediaIcons?.sectionColor?.text || '#fff',
              }"      

        />
      </div>
    </div>
  </div>
</template>

<script>
import SocialList from "./layout/SocialList.vue";
import SocialGrid from "./layout/SocialGrid.vue";
import SocialWarp from "./layout/SocialWarp.vue";
import SocialGrid2 from "./layout/SocialGrid2.vue";
import SocialExpandable from "./layout/SocialExpandable.vue";
import SocialListGrouped from "./layout/SocialListGrouped.vue";
import SocialRibbonList from "./layout/SocialRibbonList.vue";

import svgFacebook from "../../../../content/svgLoader/svgFile/svgFacebook";
import svgDribbble from "../../../../content/svgLoader/svgFile/svgDribbble";
import svgPinterest from "../../../../content/svgLoader/svgFile/svgPinterest";
import svgTelegram from "../../../../content/svgLoader/svgFile/svgTelegram";
import svgWhatsapp from "../../../../content/svgLoader/svgFile/svgWhatsapp";
import svgInstagram from "../../../../content/svgLoader/svgFile/svgInstagram";
import svgGithub from "../../../../content/svgLoader/svgFile/svgGithub";
import svgTiktok from "../../../../content/svgLoader/svgFile/svgTiktok";
import svgEmail from "../../../../content/svgLoader/svgFile/svgEmail";
import svgLocation from "../../../../content/svgLoader/svgFile/svgLocation";
import svgEitaa from "../../../../content/svgLoader/svgFile/pr/svgEitaa";
import svgSoroush from "../../../../content/svgLoader/svgFile/pr/svgSoroush";
import svgBale from "../../../../content/svgLoader/svgFile/pr/svgBale";
import svgLinkedin from "../../../../content/svgLoader/svgFile/svgLinkedin";
import svgLinkedinCo from "../../../../content/svgLoader/svgFile/svgLinkedinCo.vue";
import svgAparat from "../../../../content/svgLoader/svgFile/pr/svgAparat";
import svgGap from "../../../../content/svgLoader/svgFile/pr/svgGap";
import svgDivar from "../../../../content/svgLoader/svgFile/pr/svgDivar";
import svgSheypour from "../../../../content/svgLoader/svgFile/pr/svgSheypour";
import svgTwitter from "../../../../content/svgLoader/svgFile/svgTwitter";
import svgSkype from "../../../../content/svgLoader/svgFile/svgSkype";
import svgYoutube from "../../../../content/svgLoader/svgFile/svgYoutube";
import svgWechat from "../../../../content/svgLoader/svgFile/svgWechat";
import svgViber from "../../../../content/svgLoader/svgFile/svgViber";
import svgRubika from "../../../../content/svgLoader/svgFile/pr/svgRubika";
import svgDigikala from "../../../../content/svgLoader/svgFile/pr/svgDigikala";
import svgBasalam from "../../../../content/svgLoader/svgFile/pr/svgBasalam";
import svgSnappshop from "../../../../content/svgLoader/svgFile/pr/svgSnappshop";
import svgTechnolife from "../../../../content/svgLoader/svgFile/pr/svgTechnolife";
import svgTorob from "../../../../content/svgLoader/svgFile/pr/svgTorob";
import svgEmalls from "../../../../content/svgLoader/svgFile/pr/svgEmalls";
import SvgBase from "@/view/content/svgLoader/svgBase";
import svgCafebazaar from "../../../../content/svgLoader/svgFile/pr/svgCafebazaar.vue";
import svgGoogleplay from "../../applicaion/cm/svgGoogleplay.vue";
import svgApple from "../../applicaion/cm/svgAppstore.vue"
import svgSamsung from "../../applicaion/cm/svgSamsungstore.vue";




export default {
  name: "viewSocial",

  props: {
    value: { type: Object, default: () => ({}) },
    showHeader: { type: Boolean, default: false }
  },

  components: {
  SocialGrid,
  SocialList,
  SocialWarp,
  SocialGrid2,
  SocialExpandable,
  SocialListGrouped,
  SocialRibbonList,
    SvgBase,
    svgFacebook,
    svgDribbble,
    svgPinterest,
    svgTelegram,
    svgWhatsapp,
    svgInstagram,
    svgGithub,
    svgTiktok,
    svgEmail,
    svgLocation,
    svgEitaa,
    svgSoroush,
    svgBale,
    svgLinkedin,
    svgAparat,
    svgGap,
    svgDivar,
    svgSheypour,
    svgTwitter,
    svgSkype,
    svgYoutube,
    svgWechat,
    svgViber,
    svgRubika,
    svgDigikala,
    svgBasalam,
    svgSnappshop,
    svgTechnolife,
    svgTorob,
    svgEmalls,
     svgCafebazaar, 
    svgGoogleplay, svgApple, svgSamsung,svgLinkedinCo
  },
  
  data() {
    return {
      showMedia: true,
    };
  },
  computed: {
    resolvedMedias() {
      let extra = [];
      if (this.value && this.value.socialMedia) {
        Object.entries(this.value.socialMedia).forEach(([key, items]) => {
          items.forEach(item => {
            const resolvedSvg = this.$options.components[item.svg] || item.svg;
            extra.push({ ...item, name: key.toLowerCase(), svg: resolvedSvg });
          });
        });
      }
      return extra;
    },
  },
  methods: {
    toggleMedia() {
      this.showMedia = !this.showMedia;
    },
    hexToRgba(hex, opacity) {
      if (!hex) return 'rgba(255, 255, 255, 0.2)';
      let c;
      if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c = hex.substring(1).split('');
        if(c.length === 3) c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+opacity+')';
      }
      return hex; 
    },
    getSocialColor(name) {
      const colors = {
        instagram: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
        whatsapp: '#43FE88',
        telegram: '#4FBFF7',
        linkedin: '#59BAEE',
        twitter: '#51BAFB',
        facebook: '#5B9BF0',
        youtube: '#F76363',
        github: '#C9C7C7',
        tiktok: '#000000',
        email: '#F88A80',
        location: '#70A5F9',
        'divar': '#F65D5D',      // دیوار (قرمز مایل به زرشکی)
  'sheypoor': '#7EBCFF',   // شیپور (آبی)
  'torob': '#FA7E8B',      // ترب (قرمز)
  'emalls': '#FBBB73',     // ایمالز (نارنجی)
  'basalam': '#F97C80',    // باسلام (قرمز-صورتی)
  'digikala': '#F896A1',   // دیجی‌کالا (قرمز)
  'apple': '#D4EAF7',      // اپل (خاکستری)
  'samsung': '#6279F7',    // سامسونگ (آبی تیره)
  'email': '#F5C66A',      // ایمیل (زرد-نارنجی)
  'snapp': '#77F0A7',      // اسنپ (سبز)
  'technolife': '#7AABFA', // تکنولایف (آبی)
  'dribbble': '#FF97BF'    // دریبل (صورتی)

      };
      return colors[name] || '#C6D6E3';
    },
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern) setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }
      window.open(setUrl + url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-area { position: relative; }
.contact-area, .contact, .media-container {
  box-sizing: border-box !important;
  max-width: 100% !important;
  overflow-x: hidden;
}

.contact-area * {
  box-sizing: border-box !important;
}
.media-container {
  max-height: 0;
  overflow: hidden;
  padding: 0px !important;
  width: 100%;
  transition: max-height 0.6s ease-in-out;
  &.active { max-height: 2000px; }
}

.glass-effect {
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}
</style>
